/**
 * lettersyard Theme JS
 * Production-quality script for premium craft heritage theme
 */

'use strict';

(function () {

  /* ============================================================
     1. Announcement Bar — dismiss with localStorage persistence
     ============================================================ */
  function initAnnouncementBar() {
    var bar = document.querySelector('[data-announcement-bar]');
    if (!bar) return;

    var STORAGE_KEY = 'ly_announcement_dismissed';
    var dismissedAt = localStorage.getItem(STORAGE_KEY);

    // Check if it was dismissed in the last 7 days
    if (dismissedAt) {
      var daysSince = (Date.now() - parseInt(dismissedAt, 10)) / (1000 * 60 * 60 * 24);
      if (daysSince < 7) {
        bar.style.display = 'none';
        return;
      }
    }

    var dismissBtn = bar.querySelector('[data-announcement-dismiss]');
    if (!dismissBtn) return;

    dismissBtn.addEventListener('click', function () {
      bar.style.transition = 'max-height 0.3s ease, opacity 0.3s ease, padding 0.3s ease';
      bar.style.overflow = 'hidden';
      bar.style.maxHeight = bar.offsetHeight + 'px';
      // Force reflow
      bar.offsetHeight; // eslint-disable-line no-unused-expressions
      bar.style.maxHeight = '0';
      bar.style.opacity = '0';
      bar.style.paddingTop = '0';
      bar.style.paddingBottom = '0';

      localStorage.setItem(STORAGE_KEY, Date.now().toString());

      bar.addEventListener('transitionend', function () {
        bar.style.display = 'none';
      }, { once: true });
    });
  }

  /* ============================================================
     2. Sticky Header — add .is-scrolled class on scroll
     ============================================================ */
  function initStickyHeader() {
    var header = document.querySelector('.site-header');
    if (!header) return;

    var scrollThreshold = 10;
    var ticking = false;

    function updateHeader() {
      if (window.scrollY > scrollThreshold) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(updateHeader);
        ticking = true;
      }
    }, { passive: true });

    // Run once on load
    updateHeader();
  }

  /* ============================================================
     3. Mobile Nav Toggle — hamburger open/close with aria
     ============================================================ */
  function initMobileNav() {
    var toggleBtn = document.querySelector('[data-mobile-nav-toggle]');
    var mobileNav = document.querySelector('[data-mobile-nav]');
    var closeBtn = document.querySelector('[data-mobile-nav-close]');
    var overlay = document.querySelector('[data-mobile-nav-overlay]');

    if (!toggleBtn || !mobileNav) return;

    function openNav() {
      mobileNav.classList.add('is-open');
      toggleBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';

      // Focus the close button for accessibility
      if (closeBtn) {
        setTimeout(function () { closeBtn.focus(); }, 50);
      }
    }

    function closeNav() {
      mobileNav.classList.remove('is-open');
      toggleBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      toggleBtn.focus();
    }

    toggleBtn.addEventListener('click', function () {
      var isOpen = mobileNav.classList.contains('is-open');
      if (isOpen) {
        closeNav();
      } else {
        openNav();
      }
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', closeNav);
    }

    if (overlay) {
      overlay.addEventListener('click', closeNav);
    }

    // Close on Escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mobileNav.classList.contains('is-open')) {
        closeNav();
      }
    });

    // Close if window resizes to desktop
    var mq = window.matchMedia('(min-width: 768px)');
    mq.addEventListener('change', function (e) {
      if (e.matches && mobileNav.classList.contains('is-open')) {
        closeNav();
      }
    });
  }

  /* ============================================================
     4. Intersection Observer — fade-in on scroll
     ============================================================ */
  function initScrollAnimations() {
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) return;

    var elements = document.querySelectorAll('.animate-fade-in');
    if (!elements.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.12,
      rootMargin: '0px 0px -40px 0px'
    });

    elements.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ============================================================
     5. Cart Icon Badge Updater
     Listens for Shopify cart:updated event and updates count bubble
     ============================================================ */
  function initCartBadge() {
    var badge = document.querySelector('[data-cart-count]');
    if (!badge) return;

    function updateBadge(count) {
      badge.textContent = count > 0 ? count : '';
      badge.setAttribute('data-count', count);
      badge.setAttribute('aria-label', count + ' item' + (count !== 1 ? 's' : '') + ' in cart');
    }

    // Listen for Shopify theme cart update events
    document.addEventListener('cart:updated', function (e) {
      if (e.detail && typeof e.detail.itemCount !== 'undefined') {
        updateBadge(e.detail.itemCount);
      }
    });

    // Also handle section:load events for Shopify sections API
    document.addEventListener('shopify:section:load', function () {
      // Re-query if section reloads
      badge = document.querySelector('[data-cart-count]');
    });
  }

  /* ============================================================
     6. Disclosure / Accordion Patterns
     ============================================================ */
  function initDisclosures() {
    document.querySelectorAll('[data-disclosure-toggle]').forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var targetId = toggle.getAttribute('data-disclosure-target');
        var target = targetId ? document.getElementById(targetId) : null;
        var expanded = toggle.getAttribute('aria-expanded') === 'true';

        toggle.setAttribute('aria-expanded', String(!expanded));
        if (target) {
          target.hidden = expanded;
        }
      });
    });
  }

  /* ============================================================
     7. Smooth scroll for anchor links
     ============================================================ */
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
      anchor.addEventListener('click', function (e) {
        var target = document.querySelector(this.getAttribute('href'));
        if (!target) return;

        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });

        // Set focus for accessibility
        target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
      });
    });
  }

  /* ============================================================
     8. Accessible navigation restoration
     ============================================================ */
  function announceNavigation() {
    var main = document.getElementById('MainContent');
    if (!main) return;

    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'auto';
    }
  }

  /* ============================================================
     Init — run all modules on DOMContentLoaded
     ============================================================ */
  document.addEventListener('DOMContentLoaded', function () {
    initStickyHeader();
    initMobileNav();
    initScrollAnimations();
    initCartBadge();
    initDisclosures();
    initSmoothScroll();
    announceNavigation();
  });

  // Re-run scroll animations when Shopify sections are re-rendered
  document.addEventListener('shopify:section:load', function () {
    initScrollAnimations();
  });

})();
